import { useTheme } from '../../../../theme';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Money as MoneyType } from '../../../../types';
import { SimpleFlightPrice } from '../SimpleFlightPrice/SimpleFlightPrice';
import cn from 'classnames';
import Money from '../../../../Money/components/Money';
import * as React from 'react';
import PriceInMiles from '../../../../PriceInMiles/PriceInMiles';
import { InfoMessagesFragment } from '@websky/graphql';

interface Props {
	price: MoneyType;
	originalPrice?: MoneyType;
	best?: boolean;
	priceInMiles?: number;
	canBePaidByMiles?: boolean;
	singleFlight?: boolean;
	hideOnlyPrice?: boolean;
	subsidized?: boolean;
	seatsLeft?: number;
	flightMessages: InfoMessagesFragment[];
}

export const MinFlightPrice: React.FC<Props> = ({
	price,
	originalPrice,
	best,
	singleFlight,
	canBePaidByMiles,
	priceInMiles,
	hideOnlyPrice,
	subsidized,
	seatsLeft,
	flightMessages
}) => {
	const { FlightPriceStyles: css } = useTheme('DesktopFlightRoute');
	const { t } = useTranslation('DesktopFlightInfo');

	const isOriginalPriceIsTooBig = useMemo(() => originalPrice && originalPrice.amount > 100000, [originalPrice]);

	return (
		<SimpleFlightPrice
			singleFlight={singleFlight}
			best={best}
			subsidized={subsidized}
			originalPriceOrLabel={
				<>
					{!originalPrice && !hideOnlyPrice && (
						<div className={cn(css.selectFrom_best)}>{t(singleFlight ? 'from' : 'Select from')}</div>
					)}
					{originalPrice && (
						<div>
							{isOriginalPriceIsTooBig && <div>{t(singleFlight ? 'from' : 'Select from')}</div>}

							<Money money={originalPrice} moneyClassName={css.price_original} strikethrough />
						</div>
					)}
				</>
			}
			price={
				!hideOnlyPrice ? (
					<div className={cn(css.prices__wrp)}>
						{!priceInMiles && (
							<>
								{originalPrice && !isOriginalPriceIsTooBig && (
									<div
										className={cn({
											[css.selectFrom_best]: !singleFlight && best && !originalPrice
										})}
									>
										{t(singleFlight ? 'from' : 'Select from')}
									</div>
								)}
								<Money
									moneyClassName={cn(css.price__money, {
										[css.price__money_withPromoCode]: originalPrice,
										[css.price__money_tooBig]: isOriginalPriceIsTooBig
									})}
									money={price}
								/>
							</>
						)}

						{priceInMiles > 0 && (
							<PriceInMiles
								amount={priceInMiles}
								moneyClassName={cn(css.price__money, css.price_miles)}
								currencyClassName={css.currency}
							/>
						)}
					</div>
				) : (
					t('Select')
				)
			}
			additionalTaxes={
				priceInMiles > 0 && (
					<div className={css.miles__taxes}>
						{t('taxes and fees')}: <Money money={price} />
					</div>
				)
			}
			seatsLeft={seatsLeft}
			flightMessages={flightMessages}
		/>
	);
};
